"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserOnboarding = void 0;
const auth_1 = require("@completeanatomy/auth");
const event_bus_1 = require("@completeanatomy/event-bus");
const http_1 = require("@completeanatomy/http");
const storage_1 = require("@completeanatomy/storage");
const store_1 = require("@completeanatomy/store");
const user_1 = require("@completeanatomy/user");
require("reflect-metadata");
const typedi_1 = require("typedi");
let UserOnboarding = class UserOnboarding {
    constructor(auth, store, eventBus, http, storage, user) {
        this.auth = auth;
        this.store = store;
        this.eventBus = eventBus;
        this.http = http;
        this.storage = storage;
        this.user = user;
        /**
         * Native storage key
         * @private
         */
        this.storageKey = 'currentUserOnboarding';
        /**
         * Native storage key for new user survey data
         */
        this.newUserSurveyStorageKey = 'newUserSurvey';
        /**
         * Native storage key for new user survey successfully upload flag
         */
        this.newUserSurveyWasUploadedToBackendKey = 'newUserSurveyWasUploadedToBackend';
        this.userSkippedNewUserSurveyKey = 'userSkippedNewUserSurvey';
        this.eventBus.on(event_bus_1.AuthEvent.Authenticated, () => __awaiter(this, void 0, void 0, function* () {
            const newUserSurveyData = yield this.getNewUserSurveyDataFromNativeCache();
            /**
             * Send cached new user survey data to the server on authentication
             * Remove cached data if request was successful
             */
            if (newUserSurveyData) {
                const response = yield this.saveNewUserSurveyToBackend(newUserSurveyData);
                if (response.ok) {
                    yield this.user.fetchData(); //Fetch user data to update user kind.
                    yield this.setNewUserSurveyWasUploadedToBackend(true);
                    yield this.removeNewUserSurveyFromNativeCache();
                }
            }
        }));
        this.eventBus.on(event_bus_1.AuthEvent.Authenticated, () => __awaiter(this, void 0, void 0, function* () {
            yield this.user.fetchData();
        }));
        this.eventBus.on(event_bus_1.AuthEvent.NeedUpdateUserData, () => {
            this.user.fetchData();
        });
        this.eventBus.on(event_bus_1.AuthEvent.NeedClearUserData, () => {
            this.clear();
        });
    }
    /**
     * Clears onboarding data from AppState
     */
    clear() {
        this.storage.delete(this.storageKey);
        this.storage.delete(this.newUserSurveyWasUploadedToBackendKey);
    }
    /**
     * Saves new user survey data to the backend or to the native cache if user is not authenticated
     *
     * @param newUserSurveyData - new user survey form data
     */
    saveNewUserSurveyData(newUserSurveyData) {
        return __awaiter(this, void 0, void 0, function* () {
            const { isOffline = true } = this.store.getState().deviceInformation || {};
            yield this.setUserSkippedNewUserSurvey(false);
            if (this.auth.isAuthenticated() && !isOffline) {
                const response = yield this.saveNewUserSurveyToBackend(newUserSurveyData);
                if (response.ok) {
                    yield this.user.fetchData();
                    yield this.setNewUserSurveyWasUploadedToBackend(true);
                    return;
                }
            }
            /**
             * If app is offline, data will be saved to the native cache
             * and will be sent to the backend when user will authenticate again
             */
            yield this.saveNewUserSurveyToNativeCache(newUserSurveyData);
        });
    }
    /**
     * Returns true if new user survey data is cached in the native cache or was uploaded to the backend
     */
    hasSavedNewUserSurveyData() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.getNewUserSurveyDataFromNativeCache();
            const newUserSurveyWasUploadedToBackend = yield this.getNewUserSurveyWasUploadedToBackend();
            return !!data || !!newUserSurveyWasUploadedToBackend;
        });
    }
    getUserSkippedNewUserSurvey() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.storage.get(this.userSkippedNewUserSurveyKey);
        });
    }
    setUserSkippedNewUserSurvey(value) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storage.put(this.userSkippedNewUserSurveyKey, value);
        });
    }
    saveNewUserSurveyToBackend(newUserSurveyData) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.http.patch({
                path: 'users/sso-profile/', // @todo replace this endpoint with SSO when it will be ready
                version: 13,
                data: {
                    kind: newUserSurveyData.type,
                    speciality: newUserSurveyData.speciality,
                    graduation_year: newUserSurveyData.year,
                },
            });
        });
    }
    /**
     * TODO: Refactor Speciality (ca-modules)/Specialty (bridge-schema).
     * There's a misalignment of how these two are type-defined/used.
     */
    //Retrieve new user survey data from the Accounts backend.
    getNewUserSurveyDataFromBackend() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.get({
                path: 'api/v1/account/',
                backend: http_1.Backend.SSO,
                apiPrefix: http_1.APIPrefix.None,
            });
            if (!response.ok) {
                console.error('Failed to fetch new user survey data from backend.', response);
                return {
                    type: undefined,
                    speciality: undefined,
                    year: undefined,
                };
            }
            const responseData = yield response.json();
            const surveyData = {
                type: responseData.kind,
                speciality: responseData.speciality,
                year: responseData.study_year,
            };
            return surveyData;
        });
    }
    /**
     * Saves new user survey data to the native cache
     *
     * @param newUserSurveyData - new user survey form data
     */
    saveNewUserSurveyToNativeCache(newUserSurveyData) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storage.put(this.newUserSurveyStorageKey, newUserSurveyData);
        });
    }
    getNewUserSurveyDataFromNativeCache() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.storage.get(this.newUserSurveyStorageKey));
        });
    }
    removeNewUserSurveyFromNativeCache() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storage.delete(this.newUserSurveyStorageKey);
        });
    }
    getNewUserSurveyWasUploadedToBackend() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.storage.get(this.newUserSurveyWasUploadedToBackendKey);
        });
    }
    setNewUserSurveyWasUploadedToBackend(value) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storage.put(this.newUserSurveyWasUploadedToBackendKey, value);
        });
    }
};
exports.UserOnboarding = UserOnboarding;
UserOnboarding.exportName = 'userOnboarding';
exports.UserOnboarding = UserOnboarding = __decorate([
    (0, typedi_1.Service)(),
    __param(1, (0, typedi_1.Inject)(store_1.StoreToken)),
    __metadata("design:paramtypes", [auth_1.Auth, Object, event_bus_1.EventBus,
        http_1.HTTP,
        storage_1.Storage,
        user_1.User])
], UserOnboarding);
